import React, {useRef, useState, useEffect, Fragment} from 'react';
import Typography from '@material-ui/core/Typography';
import Battery from './Battery';
import Grid from '@material-ui/core/Grid';
import PersonIcon from '@material-ui/icons/Person';
import SettingsIcon from '@material-ui/icons/Settings';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import Slide from '@material-ui/core/Slide';
import {Popover, List, Popup, Explanation_text, Timer} from '../components';
import NotificationsIcon from '@material-ui/icons/Notifications';
import VideoIcon from '@material-ui/icons/YouTube';
import FilterListIcon from '@material-ui/icons/FilterList';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SearchIcon from '@material-ui/icons/Search';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import BugReportIcon from '@material-ui/icons/BugReport';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';
import HelpIcon from '@material-ui/icons/HelpOutline';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import ExtensionIcon from '@material-ui/icons/Extension';
import ReferIcon from '@material-ui/icons/AccountBalanceWallet';
import PaymentIcon from '@material-ui/icons/Payment';
import HomeIcon from '@material-ui/icons/Home';
import EmailIcon from '@material-ui/icons/Email';
import ErrorIcon from '@material-ui/icons/Error';
import Snackbar from '@material-ui/core/Snackbar';
import Filter from './Filter';
import Search from './Search';
import FreeTrialReminder from './FreeTrialReminder';
// //IF YOU USE THIS MAKE SURE NOT TO CREATE STRIPE ERROR SO LOAD ONLY IF NECESSARY.  import {loadStripe} from '@stripe/stripe-js';
import { makeStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';
import axios from 'axios';



const useStyles = makeStyles((theme) => ({
  header:{
    backgroundColor:theme.palette.primary.main,
    marginLeft:'0px',
    width:'100vw',
    ['@media (min-width:600px)']:{
      marginLeft:(props)=>{if(window.innerWidth<960 && props.width=='34vw'){return '0px';}else{return 'calc(100vw - '+props.width+')'}},
      width:(props)=>{if(window.innerWidth<960 && props.width=='34vw'){return '100vw';}else{return props.width}},
    },
  },
  secondary_colour:{
    color:theme.palette.secondary.main
  },
  link:{color:theme.palette.tertiary.main},
  countdownContainer:{
    backgroundColor:theme.palette.secondary.main,
    ['@media (max-width: 900px)']:{
    display:'none'
  }
}}));


function Navigation(props){
  const[full_screen, setFullScreen]=useState(document.getElementById('extension_check').innerText!='Yes');
  const[small_mode, setSmallMode]=useState(true);
  const[medium_mode, setMediumMode]=useState(false);
  const[referral_popup, setReferralPopup]=useState(false);
  const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());
  const [free_trial_deadline, setFreeTrialDeadline]=useState();
  const [smtp_data_array, setSmtpData]=useState([]);
  const [trustpilot_review_request_sent, setTrustpilotReviewRequestSent]=useState(false);

  let smtp_data={empty:true, daily_limit:100, hourly_limit:45, seconds_delay:60, daily_emails:0, hourly_emails:0, pending_emails:0, inbox_emails:0, smtp_connection:'Click to connect your email'};
  for(let s of smtp_data_array){if(smtp_data.pending_emails<s.pending_emails || smtp_data.empty==true){smtp_data=s;}}



  function triggerOpen(){axios.get('/api/email/smtp_logins/sending_limits').then((response)=>{setSmtpData(response.data);})}


  let last_width=useRef(0);
  let classes=useStyles(props);
  console.log(props.workspace, 'FREE TRIAL DEDLINE');
  if(free_trial_deadline==undefined && props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.canceled_on!=null){
    setFreeTrialDeadline(getDateTimeHere(props.workspace.active_subscription.canceled_on));
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime(getDateTimeHere(props.workspace.active_subscription.canceled_on)));
    }, 1000);
  }else if(free_trial_deadline==undefined && props.workspace!=undefined && props.workspace.free_trial_deadline!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true){
    setFreeTrialDeadline(getDateTimeHere(new Date(props.workspace.free_trial_deadline)));
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime(props.workspace.free_trial_deadline));
    }, 1000);
  }else if(free_trial_deadline==undefined && props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true){
    setFreeTrialDeadline(getDateTimeHere(new Date(new Date(props.workspace.active_subscription.created_at).getTime() + (15 * 24 * 60 * 60 * 1000)).toISOString().slice(0, 19).replace("T", " ")));
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime(getDateTimeHere(new Date(new Date(props.workspace.active_subscription.created_at).getTime() + (15 * 24 * 60 * 60 * 1000)).toISOString().slice(0, 19).replace("T", " "))));
    }, 1000);
  }
  console.log(remainingTime, 'REMAINING TIME');
  function calculateRemainingTime(free_trial_deadline) {
    console.log(free_trial_deadline, 'FREE TRIALL DEADLINE');
    if(free_trial_deadline!=undefined){
      const currentTime = Math.floor(Date.now() / 1000);
      const deadlineTime = Math.floor(new Date(free_trial_deadline).getTime() / 1000);
      const remainingSeconds = deadlineTime - currentTime;
      if (remainingSeconds <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }
      const days = Math.floor(remainingSeconds / (24 * 60 * 60));
      const hours = Math.floor((remainingSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((remainingSeconds % (60 * 60)) / 60);
      const seconds = Math.floor(remainingSeconds % 60);
      return { days, hours, minutes, seconds };
    }
  }

  const formatTime = (value) => {
    return value.toString().padStart(2, '0');
  };



  function click_list(x){
    if(x.id=='extension'){window.location.href='/extensionLink';}
    else if(x.id=='refer'){navigator.clipboard.writeText('https://'+window.location.hostname+'/refb/'+x.referral_code); window.setTimeout(function(){setReferralPopup(true);},100);}
    else if(x.id=='help'){open('https://prospectsafari.com/docs/user-guide/tutorials/new-user/', 'help_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0');}
    else if(x.id=='support'){open('https://join.skype.com/invite/atqq46nNCXdl', 'support_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0')}
    else if(x.id=='canny'){open('https://prospectsafari.canny.io/ ', 'support_box', 'height='+window.outerHeight+', width='+window.screenX+', top='+window.screenY+', left=0')}
    else if(x.id=='setup'){if(props.extension==true){props.history.push('/setup/extension');}else{props.history.push('/setup')}}
    else if(x.id=='switch_workspace'){localStorage.removeItem('extension_list_id'); props.switchWorkspace()}
    else if(x.id=='logout'){localStorage.removeItem('extension_list_id'); props.logout()}
    else if(x.id=='full_screen'){if(full_screen==false){openFullScreen(); setFullScreen(true);}else{closeFullScreen(); setFullScreen(false);}}
    else if(x.id=='home'){let url='/companies/table'; if(props.extension==true){url='/extension/content/892jakafsoi23rj9jf29qcm';}  let parts=props.location.pathname.split('/f/'); let before=parts[0]; let filter=(parts.length>0)?parts[1]:undefined; parts=before.split('/q/'); let query=(parts.length>0)?parts[1]:undefined; parts=parts[0].split('/o/'); let order=(parts.length>0)?parts[1]:undefined; parts=parts[0].split('/k/'); let columns=(parts.length>0)?parts[1]:undefined; if(columns!=undefined){url=url+'/k/'+columns;} if(order!=undefined){url=url+'/o/'+order;} if(query!=undefined){url=url+'/q/'+query;} if(filter!=undefined){url=url+'/f/'+filter;} props.history.push(url);}
  }

  function openFullScreen() {let elem=document.getElementsByTagName('body')[0]; if (elem.requestFullscreen) {elem.requestFullscreen();} else if (elem.webkitRequestFullscreen) { /* Safari */elem.webkitRequestFullscreen();} else if (elem.msRequestFullscreen) { /* IE11 */elem.msRequestFullscreen();}}
  function closeFullScreen() {if (document.exitFullscreen) {document.exitFullscreen();} else if (document.webkitExitFullscreen) { /* Safari */document.webkitExitFullscreen();} else if (document.msExitFullscreen) { /* IE11 */document.msExitFullscreen();}}



    if(last_width.current!=props.width){
      last_width.current=props.width;
      onWindowResize();
    }
    let workspace={}
    let user_workspace={}
    if(props.workspace!=undefined){workspace=props.workspace; for(let uw_key of Object.keys(workspace.user_workspaces)){let uw=workspace.user_workspaces[uw_key]; if(uw.user_id==props.me.id){user_workspace=uw;}}}
    window.addEventListener('resize', onWindowResize);
    function onWindowResize() {
      let actual_width=window.innerWidth;
      if((actual_width>600 && props.width!='34vw') || actual_width>960){actual_width=(actual_width/100)*Number(props.width.replace('vw', ''));}
      if(actual_width<500){setMediumMode(false); setSmallMode(true);}else if(actual_width<650){if(props.width=='100vw'){setMediumMode(false);}else{setMediumMode(true);} setSmallMode(false);}else{setMediumMode(false); setSmallMode(false);}
    }
    let list_to_click=[
        {id:'home', main_text:'Home', icon:<HomeIcon color='primary'/>},
        {id:'full_screen', main_text:(full_screen==true)?'Small screen':'Full screen', icon:<FullscreenIcon color='primary'/>},
        {id:'setup', main_text:props.me.first_name+' '+props.me.last_name, icon:<SettingsIcon color='primary'/>},
        {id:'switch_workspace', main_text:'Switch workspace', icon:<SwapVertIcon color='primary'/>},
        {id:'logout', main_text:'Logout', icon:<LogoutIcon color='primary'/>},
        {id:'help', main_text:'Help', icon:<HelpIcon color='primary'/>},
        {id:'support', main_text:'Support', icon:<PersonIcon color='primary'/>},
        {id:'canny', main_text:'Feedback', icon:<BugReportIcon color='error'/>}
      ];

    if(document.getElementById('extension_check').innerText!='Yes'){list_to_click.push({id:'extension', main_text:'Download Extension', icon:<ExtensionIcon color='primary'/>})}
    if(props.me.referral_code!=undefined){list_to_click.push({id:'refer', referral_code:props.me.referral_code, main_text:<Tooltip title={props.me.referral_code_count+' successful referrals'}><span>Earn credits: refer a friend</span></Tooltip>, icon:<ReferIcon color='primary'/>})}
    let monthly_credits=0;
    let pay_users=[];
    if(props.workspace!=undefined){for(let key in props.workspace.user_workspaces){let uw=props.workspace.user_workspaces[key]; if(uw.new!=true && uw.user_id!=null && uw.superuser!=true && uw.disabled!=true){pay_users.push(uw);}}}
    if(props.subscriptions!=undefined && props.workspace!=undefined && props.workspace.active_subscription!=null){
      for(let s of props.subscriptions){if(s.id==props.workspace.active_subscription.prospect_safari_service_id){monthly_credits+=s.credits*props.workspace.active_subscription.quantity; break;}}
      for(let ae of props.workspace.active_subscription.active_subscription_extras){for(let s of props.subscriptions){if(ae.prospect_safari_service_id==s.id){monthly_credits+=s.credits*props.workspace.active_subscription.quantity;}}}
    }


    //THIS SHOULD BECOME AN INTERACTIVE THING WHERE WE GIVE CREDITS OR SOMETHING IN EXCHANGE.
    let requested_review=useRef(false);
    console.log(props, props.me, 'WHAR NAVIDATION');
    if(props.me!=undefined && props.me.request_review!=undefined && requested_review.current==false){
      requested_review.current=true;
      axios.post('/api/admin/requestProspectSafariReview/'+props.me.request_review).then(()=>{
        setTrustpilotReviewRequestSent(true);
        tp('createInvitation', {
       			recipientEmail: props.me.email,
       			recipientName: props.me.first_name,
       			referenceId: props.me.id,
       			source: 'InvitationScript',
      		});
      });
    }

//<div><Typography variant='caption'>{'+ '+convertable+' convertable'}</Typography></div>

    return(
      <div id='pv_wiz_1' className={classes.header} style={{zIndex:'100000000',  position:'fixed', top:'0px', left:'0px', display:'flex', justifyContent:'center', alignItems:'center', boxShadow:'2px 2px 5px 2px #000000', height:'30px'}}>
              {(remainingTime==undefined || props.view_mode==true)?null:
                <div className={classes.countdownContainer} style={{position: 'absolute', top: '0px', left: '60px', width: '240px', height: '30px', borderRadius: '0px', overflow: 'hidden' }}>
                  <a onClick={()=>{
                    if(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.canceled_on!=null){window.location.href='/payments/active';}
                    else if(props.workspace.active_subscription.stripe_user==undefined || props.workspace.active_subscription.stripe_user.payment_method==false){window.location.href="/my/personal/customer/portal";}
                    else{window.location.href='/payments/active?end_free_trial=true';}
                  }} style={{ textDecoration: 'none', cursor:'pointer' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', fontFamily: 'Arial, sans-serif', color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>
                      <span style={{ marginRight: '5px' }}>{(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.canceled_on!=null)?'Cancels in':'Trial Ends In'}</span>
                      <span style={{ marginRight: '5px' }}>{formatTime(remainingTime.days)} Days</span>
                      <span style={{ marginRight: '5px' }}>{formatTime(remainingTime.hours)}:{formatTime(remainingTime.minutes)}:{formatTime(remainingTime.seconds)}</span>
                    </div>
                  </a>
                </div>
              }
              <div style={{position:'absolute', left:'10px', top:'2px'}}><ClickIcons {...props}/></div>
              {(small_mode==false)?
              <Fragment>
                {(medium_mode==true)?null:<div onClick={()=>{click_list({id:'home'})}} style={{fontSize:'24px', color:'white', fontFamily:'Comfortaa', cursor:'pointer'}}>Prospect<span className={classes.secondary_colour}>Safari</span>{(props.workspace!=undefined && props.workspace.custom_logo!=undefined)?<span style={{fontSize:'15px', marginLeft:'5px'}}>{" and "}<img onClick={()=>{click_list({id:'home'})}} style={{width:'25px', marginLeft:'5px', marginTop:'4px', marginBottom:'-4px'}} src={'/images/custom_logos/'+props.workspace.custom_logo}/></span>:null}</div>}
                <img onClick={()=>{click_list({id:'home'})}} style={{position:(medium_mode==true)?null:'absolute', width:(medium_mode==true)?'30px':'15px', cursor:'pointer', marginLeft:(medium_mode==true)?null:(props.workspace!=undefined && props.workspace.custom_logo!=undefined)?'-193px':'-118px', marginTop:(medium_mode==true)?null:(props.workspace!=undefined && props.workspace.custom_logo!=undefined)?'7px':'2px'}} src='/images/logo.png'/>
              </Fragment>
              :null}
              <div style={{position:'absolute', right:'20px'}}>
              <Popover
                trigger={(small_mode==true)?<img style={{width:'30px', cursor:'pointer'}} src='/images/logo.png'/>:<Typography style={{color:'white', cursor:'pointer'}} onClick={triggerOpen}>{(props.workspace!=undefined)?props.workspace.name:null}</Typography>}
                content={
                  <div style={{width:'300px'}}>
                  <Fragment>
                    <Typography variant='caption' color='primary' style={{marginLeft:'10px'}}>{(props.workspace!=undefined)?props.workspace.name:null}</Typography>
                    <hr style={{width:'100%', marginTop:'-2px'}}/>
                    {(props.workspace==undefined || props.workspace.active_subscription==undefined || props.subscriptions==undefined || workspace==undefined || workspace.defaults==undefined)?null:workspace.defaults.map(function(wd){return(<Fragment>{wd.special_services.map(function(special_service){
                      let css={credits:0, average_monthly_credits:0, extra_monthly_credits:0, extra_monthly_credits_consumed:0}; for(let x of workspace.customer_of_special_services){if(x.workspace_default_special_service_id==special_service.id){css=x;}}
                      let monthly_left=(css.extra_monthly_credits - css.extra_monthly_credits_consumed); if(monthly_left<0){monthly_left=0;}
                      let pay_users=[]; let first_billing_period_users=0;
                      for(let ae of props.workspace.active_subscription.active_subscription_extras){let ps=undefined; for(let s of props.subscriptions){if(s.id==ae.prospect_safari_service_id){ps=s;}} if(ps!=undefined && special_service.default_id==ps.default_id){first_billing_period_users=ae.first_billing_period_users; for(let aeu of ae.user_workspaces){pay_users.push(aeu);}}}

                      let convertable=(Math.floor((css.extra_monthly_credits*(pay_users.length - first_billing_period_users)/special_service.credits_conversion_rate)) - css.extra_monthly_credits_consumed); if(convertable<0){convertable=0;}

                      return(
                        <Fragment>
                        <div style={{backgroundColor:(css.credits==0 || (css.average_monthly_credits/3)>css.credits)?'rgba(200, 100, 150, 0.2)':'rgba(100, 200, 150, 0.2)', paddingTop:'10px', paddingBottom:'15px', height:'35px', paddingLeft:'15px', marginBottom:'-10px', marginTop:'-10px'}}><Grid container><Grid item xs={2}><div style={{height:'35px', display:'flex', justifyContent:'center', alignItems:'center'}}><img src={special_service.logo} style={{width:'40px', marginLeft:'-15px'}}/></div></Grid><Grid item xs={1}/>
                        <Grid item xs={9}>
                              <div><Typography variant='caption'>{special_service.name+' credits: '+css.credits}</Typography></div>
                              <div><Typography variant='caption'>{'Phone scoring service.'}</Typography></div>
                        </Grid></Grid></div>
                        <hr style={{width:'100%', marginBottom:'0px'}}/>
                        </Fragment>
                      )
                    })}</Fragment>)})}
                    {(workspace.free_account==true)?<Typography color='primary' style={{textAlign:'center', marginTop:'20px', marginBottom:'20px'}}>FREE ACCOUNT</Typography>:
                    <div style={{marginTop:'5px', marginBottom:'10px', height:'55px', marginLeft:'15px'}}><Grid container><Grid item xs={2}><div style={{height:'55px'}}><Battery level={getBatteryLevel(props.workspace)}/></div></Grid><Grid item xs={1}/>
                    <Grid item xs={9}>
                          {(workspace.admin==true)?<div><Typography variant='caption'>{'Monthly credits: '+monthly_credits}</Typography></div>:<div><Typography variant='caption'>{'Monthly allowance: '+user_workspace.workspace_credits_limit}</Typography></div>}
                          {(workspace.admin==true)?<div><Typography variant='caption'>{'Credits remaining: '+Math.floor(workspace.credits)}</Typography></div>:<div><Typography variant='caption'>{'Monthly consumption: '+user_workspace.workspace_credits_consumed}</Typography></div>}
                          {(workspace.renew_credits_in==undefined)?null:<div><Typography variant='caption'>{'Renews in: '+workspace.renew_credits_in+' days'}</Typography></div>}
                    </Grid></Grid></div>}
                    <hr style={{width:'100%', marginBottom:'-10px'}}/>
                    {<Fragment>
                      <Grid container style={{marginTop:'20px', marginLeft:'10px', width:'calc(100%-10px)'}}>
                        <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><img src='/images/email.png' style={{width:'45px', cursor:'pointer'}} onClick={()=>{window.location.href='/integrations'}}/></Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={9}>
                            <Grid container>
                              <Grid item xs={12}><div style={{marginTop:'-5px'}}><Typography variant='caption'><span style={{cursor:'pointer'}} onClick={()=>{window.location.href='/integrations'}}>{smtp_data.smtp_connection}</span></Typography></div></Grid>
                              <Grid item xs={6}><div><Tooltip title="Emails sent in the last 24 hours."><Typography variant='caption'>{'Daily: '+smtp_data.daily_emails+'/'+smtp_data.daily_limit+''}</Typography></Tooltip></div></Grid>
                              <Grid item xs={6}><div><Tooltip title="Emails sent in the last 60 minutes."><Typography variant='caption'>{'Hourly: '+smtp_data.hourly_emails+'/'+smtp_data.hourly_limit+''}</Typography></Tooltip></div></Grid>
                              <Grid item xs={6}><div><Tooltip title="Counter refers to pending emails on this particular mailbox. Click to view all pending and scheduled emails."><Typography variant='caption' color='primary'><span style={{cursor:'pointer', textDecoration:'underline'}} onClick={()=>{window.location.href=props.default_filter_links.pending_emails_list_view}}>{'Pending'}</span><span>{': '+smtp_data.pending_emails}</span></Typography></Tooltip></div></Grid>
                              <Grid item xs={6}><div><Tooltip title="Click to view entire inbox."><Typography variant='caption' color='primary'><span style={{cursor:'pointer', textDecoration:'underline'}} onClick={()=>{window.location.href=props.default_filter_links.my_inbox_view}}>{'Inbox'}</span><span></span></Typography></Tooltip></div></Grid>
                            </Grid>
                        </Grid>
                      </Grid>
                      <hr style={{width:'100%', marginBottom:'-10px'}}/>
                    </Fragment>
                    }
                    <List onClick={click_list} list_data={list_to_click}/>
                  </Fragment>
                  </div>
                }
              />
              </div>
              {(trustpilot_review_request_sent==true)?<Review_request_sent {...props} handleClose={()=>{setTrustpilotReviewRequestSent(false);}}/>:null}
              {(referral_popup==true)?<Ref_popup handleClose={()=>{setReferralPopup(false);}}/>:null}
              {(free_trial_deadline==undefined || (props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.canceled_on!=null))?null:<FreeTrialReminder workspace={workspace} deadline={free_trial_deadline}/>}
      </div>

    )
}
//


function Review_request_sent(props){
  return(
    <Popup always_open title='Trustpilot review' closed={()=>{props.handleClose()}} accept_button_click={()=>{props.handleClose()}} content={
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'30px', marginBottom:'30px'}}>
          <Typography>Thanks for trusting in ProspectSafari! We are sending you a review request. Your positive review will really help us grow!</Typography>
          <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}><img  style={{width:'90%', maxWidth:'200px'}} src='/images/trustpilot_large_logo.png'/></div>
        </div>
      } button_variant='icon_button' accept_button='Ok'/>
  )
}


function Ref_popup(props){
  console.log('REF POPUP');
  return(
    <Popup always_open title='Link copied to clipboard' closed={()=>{props.handleClose()}} accept_button_click={()=>{props.handleClose()}} content={
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'30px', marginBottom:'30px'}}><Explanation_text text='ref_link_copy_text'/></div>
      } button_variant='icon_button' accept_button='Ok'/>
  )
}


function getBatteryLevel(workspace){
  let level=0;
  if(workspace!=undefined && workspace.average_monthly_credits!=null && workspace.credits!=null){
    let unit=workspace.average_monthly_credits/6
    level=Math.floor(workspace.credits/unit);
    if(level>6){level=6}else if(level==0){level=1}
    return level;
  }else{level=1;}
  return level;
}



function ClickIcons(props){

  function onChange(v){
      let url=window.location.pathname;
      url=url.split('/f')[0].split('/q')[0];
      if(v!=undefined && v!=''){url=url+'/q/'+encodeURIComponent(btoa(v));}
      if(props.current_list.filter!=undefined){url=url+'/f/'+encodeURIComponent(btoa(JSON.stringify(props.current_list.filter)));}
      props.history.push(url);
  }

  //<span style={{marginLeft:'0px', marginRight:'5px'}}><Battery level='4'/></span>

  if(props.view_mode==true){return(<div style={{display:'flex', justifyContent:'center', alignItems:'center'}}><span><Notifications {...props}/></span><span><Filter {...props} without_icon_button style={{color:'white', cursor:'pointer', marginLeft:'5px', marginRight:'5px'}}/></span><span><Search {...props} initial_value={props.current_list.query} style={{color:'white', cursor:'pointer', marginLeft:'5px', marginRight:'5px'}} onChange={onChange}/></span></div>)}
  else{return(
    <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}><span><Notifications {...props}/></span></div>

  )}
}

//if(props.me!=undefined && props.me.offer_expires_on!=null){setLimitedOfferPopup(true);}else{axios.post('/api/payments/2').then(function(response){checkout(response.data.id)});} UPGRADE DEAL ONCLICK PART;
//{(limited_offer_popup!=true)?null:<Popup accept_button={'Continue'} accept_button_click={()=>{axios.post('/api/payments/2').then(function(response){checkout(response.data.id)});}} handleClose={()=>{setLimitedOfferPopup(false)}} always_open title={'Limited time offer'} content={<Fragment>
//  {(referrer!=undefined)?<Typography style={{width:'400px', marginTop:'10px', textAlign:'center', padding:'20px'}}>{referrer+" wants you to have the full ProspectSafari experience:"}</Typography>:<Typography style={{width:'400px', marginTop:'10px', textAlign:'center', padding:'20px'}}>{"You should try the full ProspectSafari experience:"}</Typography>}
//  <Typography style={{width:'400px', marginTop:'20px', textAlign:'center', padding:'20px'}}>Upgrade now & use TEAM Edition + Addon free for 1 month!</Typography>
//  <Typography style={{width:'400px', marginTop:'30px', textAlign:'center', padding:'20px', color:'red'}}><Timer text='This offer expires in ' deadline={getDateTimeHere(props.me.offer_expires_on)} /></Typography>
//  </Fragment>
//}
///>} This goes under.
function Notifications(props){
  const[limited_offer_popup, setLimitedOfferPopup]=useState(false);
  const[popup, setPopup]=useState(undefined);
  let notifications=[];
  let notification_refresh_id=useRef(36000);
  let current_notifications=useRef([]);
  let first_time=useRef(true);
  let anchorEl=useRef();

  if(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true && (props.workspace.active_subscription.stripe_user==undefined || props.workspace.active_subscription.stripe_user.payment_method!=true)){notifications.push({id:'complete_registration', main_text:'Complete registration', icon:<PaymentIcon color='primary'/>});}
  if(document.getElementById('extension_check').innerText!='Yes'){notifications.push({id:'extension', main_text:'Download Extension', icon:<ExtensionIcon color='primary'/>})}
  if(props.workspace!=undefined && props.workspace.active_subscription!=undefined && props.workspace.active_subscription.free_trial==true){notifications.push({id:'intro_video', main_text:'Intro Video', icon:<VideoIcon color='primary'/>})}
  let stripe_key="pk_test_51IxBXwICUHW9YTF61u7Yd5bEexcExlxvniyeDVfsLzXhNLGTRssWNYCfejyivigksfIW0P3Fo5Jnz4hkmqLYOZC6000i5E87EX";
  let stripePromise;
  //IF YOU USE THIS MAKE SURE NOT TO CREATE STRIPE ERROR SO LOAD ONLY IF NECESSARY. if(props.workspace!=undefined){
//    if(props.workspace.test==false){ stripe_key='pk_live_51IxBXwICUHW9YTF6DSIomoISs3Njej53kWb1AOzjqkbzsOgv058hvtxaP81nge7eRyy74KsnVNg0sSxPKQmKzXvc00LnBQ8nni' }
//    stripePromise = loadStripe(stripe_key);
//  }
  useEffect(()=>{
    notification_refresh_id.current=setInterval(props.index_notifications, 30000);
    props.index_notifications();
  },[]);


  window.updateNotificationRefresh=function(interval, timespan) {console.log('SPEED UP'); clearInterval(notification_refresh_id.current); notification_refresh_id.current=setInterval(props.index_notifications, interval); setTimeout(function () {clearInterval(notification_refresh_id.current); notification_refresh_id.current = setInterval(props.index_notifications, 300000);}, timespan);}

  //IF YOU USE THIS MAKE SURE NOT TO CREATE STRIPE ERROR SO LOAD ONLY IF NECESSARY. async function checkout(session_id){const stripe = await stripePromise; const { error } = await stripe.redirectToCheckout({sessionId:session_id});}
  let referrer=undefined;
  if(props.me!=undefined && props.me.referred_by!=undefined){referrer=props.me.referred_by;}
  let ns={}
  let no_notifications=useRef(true);
  if(props.notifications!=undefined){
    for(let n of props.notifications){
      if(current_notifications.current.includes(n.id)==false){console.log('SET SNACKBARRR'); current_notifications.current.push(n.id); if(no_notifications.current==false){props.setSnackbar(getText(n.type), 'notifications', undefined, anchorEl.current, ()=>{onClick({id:n.type})})}}
      if(ns[n.type]==undefined){ns[n.type]=0;}
      ns[n.type]+=1;
  } no_notifications.current=false;}
  function getText(key){
    if(key=='1' || key=='EMAILS_RECEIVED'){return ' New emails received.'}
    else if(key=='11' || key=='EMAILS_SEND_ERROR'){return " Some emails didn't send"}
    else if(key=='31' || key=='SEARCH_COMPLETED'){return "Automated search completed"}
    else if(key=='3' || key=='CSV_UPLOAD_COMPLETED'){return "CSV upload completed"}
    else if(key=='32' || key=='CSV_UPLOAD_ERROR'){return 'CSV upload failed';}
    else if(key=='33' || key=='SEARCH_ERROR'){return 'Your search failed';}
    else if(key=='50' || key=='PRL_SCORING_COMPLETE'){return 'JumpStart scoring complete';}
    else if(key=='501' || key=='INTEGRATION_ERROR_CALENDAR'){return 'Calendar integration error.'}
    else if(key=='502' || key=='INTEGRATION_ERROR_SMTP'){return 'Email integration error.'}
    else if(key=='503' || key=='INTEGRATION_ERROR_HUBSPOT'){return 'Hubspot integration error';}
  }
  function getIcon(key){
    if(key=='1'||key=='EMAILS_RECEIVED'){return(<EmailIcon/>)}
    else if(key=='11' || key=='EMAILS_SEND_ERROR'){return(<EmailIcon style={{color:'red'}}/>)}
    else if(key=='31' || key=='SEARCH_COMPLETED'){return (<SearchIcon/>)}
    else if(key=='3' || key=='CSV_UPLOAD_COMPLETED'){return(<CloudUploadIcon/>);}
    else if(key=='32' || key=='CSV_UPLOAD_ERROR' || key=='33'||key=='SEARCH_ERROR'){return(<ErrorIcon style={{color:'red'}}/>);}
    else if(key=='501' || key=='502' || key=='503' || key.includes('INTEGRATION_ERROR')){return (<ErrorIcon style={{color:'red'}}/>)}
    else if(key=='50' || key=='PRL_SCORING_COMPLETE'){return(<img style={{width:'25px'}} src='/images/icons/scoring_service.png'/>);}
  }

  for(let key in ns){
    if(first_time.current==true && key=='50' || key=='PRL_SCORING_COMPLETE'){onClick({id:'50'});}
    notifications.push({id:key, main_text:getText(key), icon:getIcon(key)})
  }

  if(props.notifications!=undefined){first_time.current=false;}


  function onClick(e){
    if(e.id!='upgrade_deal' && e.id!='extension' && e.id!='complete_registration' && e.id!='intro_video'){
      axios.post('/api/notification_viewed', {type:e.id});
    }
    let filter={}; let ff=window.location.pathname.split('/f/'); if(ff.length>1){filter=JSON.parse(atob(decodeURIComponent(ff[1].split('/')[0])))}
    console.log(e, 'EEE');
    if(e.id=='intro_video'){window.location.href='/companies/table?checkout_complete=TEAM'}
    else if(e.id=='upgrade_deal'){}
    else if(e.id=='extension'){window.location.href='/extensionLink';}
    else if(e.id=='complete_registration'){window.location.href='/my/personal/customer/portal'}
    else if(e.id=='EMAILS_RECEIVED' || e.id=='1'){
      let url='/companies/table/o/eyJuYW1lIjoidGltZWxpbmVfaXRlbV9kYXRlX3RpbWUiLCJkaXJlY3Rpb24iOiJkZXNjIn0%3D/k/W10%3D/f/eyJlbnRpdHkiOiJlbWFpbHMiLCJlbWFpbF9tZXNzYWdlcyxyZWFkIjp7Im8iOiJmYWxzZSJ9LCJ0aW1lbGluZV9pdGVtcyxzdWJfdHlwZSI6eyJvIjoiMV9vZiIsInYiOlsxXX0sInNhdmVkX2ZpbHRlcl9uYW1lIjoiVW5yZWFkIEVtYWlscyIsImlkIjozNH0=/'
      window.location.href=url;
    }else if(e.id=='EMAILS_SEND_ERROR' || e.id=='11'){
      let url='/companies/table'; filter['email_messages,error']=true; filter.entity='emails'; if(filter!=undefined && Object.keys(filter).length!=0){url+='/f/'+encodeURIComponent(btoa(JSON.stringify(filter)));}
      window.location.href=url;
    }else if(e.id=='CSV_UPLOAD_COMPLETED' || e.id=='SEARCH_COMPLETED' || e.id=='3' || e.id=='31'){window.location.reload();}
    else if(e.id=='CSV_UPLOAD_ERROR' || e.id=='32'){setPopup('We encountered an error in uploading your CSV file. We are sorry for the inconvenience. We have already started fixing the issue. As soon as it is solved your file will finish uploading and you will receive a notification.');}
    else if(e.id=='SEARCH_ERROR' || e.id=='33'){setPopup('We encountered an error in completing your search. We are sorry for the inconvenience. We have already started fixing the issue. As soon as it is solved your search will finish processing and you will receive a notification.');}
    else if(e.id=='PRL_SCORING_COMPLETE' || e.id=='50'){window.location.href='/companies/table?force_video=PRL_RETURN';}
    else if(e.id.includes('INTEGRATION_ERROR') || e.id=='501' || e.id=='502' || e.id=='503'){window.location.href='/integrations';}
  }

  return(
    <Fragment>
    {(popup!=undefined)?<Popup always_open title={'An error occurred'} handleClose={()=>{setPopup(undefined);}} content={<Fragment><div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}><Typography style={{width:'calc(100% - 40px)', marginTop:'30px', marginBottom:'30px'}}>{popup}</Typography></div></Fragment>}/>:null}
    <Popover
      trigger={<Badge anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
  }} badgeContent={notifications.length} color="error"><NotificationsIcon ref={anchorEl} style={{color:'white', cursor:'pointer', marginLeft:'5px', marginRight:'5px'}}/></Badge>}
      content={
        <List onClick={onClick} list_data={notifications}/>
      }
    />
    </Fragment>
  )
}


export default connect(ss, dd)(Navigation);

function ss(state){
  return{
    default_filter_links:state.account.default_filter_links,
    me:state.account.me,
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
    workspace_refresh:state.workspaces.refresh,
    view_mode:state.account.view_mode,
    current_list:state.companies.current_list,
    subscriptions:state.account.subscriptions,
    notifications:state.account.notifications
  }
}


function dd(dispatch){
  return{
    switchWorkspace:()=>{dispatch({type:"SWITCH_WORKSPACE"})},
    logout:()=>{dispatch({type:"REQUEST_LOGOUT"})},
    reset_current_list:(info)=>{dispatch({type:'RESET_CURRENT_LIST'})},
    index_companies:(info)=>{dispatch({type:'REQUEST_INDEX_COMPANIES', ...info})},
    index_notifications:()=>{dispatch({type:'REQUEST_INDEX_NOTIFICATIONS'})},
    setSnackbar:(message, type=undefined, icon=undefined, anchorEl=undefined, onClick=undefined)=>{dispatch({type:'SET_SNACKBAR', val:{open:(message==undefined)?false:true, message:message, type:type, icon:icon, anchorEl:anchorEl, onClick:onClick}});}
  }
}
